export default function SocialController() {

}